import _defineProperty from "/tmp/builds/b48f37fc-9b5d-4b5d-b79f-27f4ff5c732b-develop-nodeV18-18/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable @typescript-eslint/no-explicit-any */


import React, { forwardRef, createElement } from "react";
import { createMakeStyles } from "./makeStyles";
import { capitalize } from "./tools/capitalize";
export function createWithStyles(params) {
  var useTheme = params.useTheme,
      cache = params.cache;

  var _createMakeStyles = createMakeStyles({
    useTheme: useTheme,
    cache: cache
  }),
      makeStyles = _createMakeStyles.makeStyles;

  function withStyles(Component, cssObjectByRuleNameOrGetCssObjectByRuleName, params) {
    var Component_ = typeof Component === "string" ? function () {
      var tag = Component;

      var Out = function Out(_a) {
        var children = _a.children,
            props = __rest(_a, ["children"]);

        return createElement(tag, props, children);
      };

      Object.defineProperty(Out, "name", {
        "value": capitalize(tag)
      });
      return Out;
    }() : Component;
    /**
     * Get component name for wrapping
     * @see https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
     */

    var name = function () {
      {
        var displayName = Component_.displayName;

        if (displayName) {
          return displayName;
        }
      }
      {
        var _name = Component_.name;

        if (_name) {
          return _name;
        }
      }
      return params === null || params === void 0 ? void 0 : params.name;
    }();

    var useStyles = makeStyles(Object.assign(Object.assign({}, params), {
      name: name
    }))(typeof cssObjectByRuleNameOrGetCssObjectByRuleName === "function" ? function (theme, props, classes) {
      return incorporateMediaQueries(cssObjectByRuleNameOrGetCssObjectByRuleName(theme, props, classes));
    } : incorporateMediaQueries(cssObjectByRuleNameOrGetCssObjectByRuleName));

    function getHasNonRootClasses(classes) {
      for (var _name2 in classes) {
        if (_name2 === "root") {
          continue;
        }

        return true;
      }

      return false;
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any


    var Out = forwardRef(function (props, ref) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var className = props.className,
          _classes = props.classes,
          rest = __rest(props, ["className", "classes"]);

      var _useStyles = useStyles(props, {
        props: props
      }),
          classes = _useStyles.classes,
          cx = _useStyles.cx;

      return React.createElement(Component_, Object.assign({
        ref: ref,
        className: getHasNonRootClasses(classes) ? className : cx(classes.root, className)
      }, typeof Component === "string" ? {} : {
        classes: classes
      }, rest));
    });

    if (name !== undefined) {
      Out.displayName = "".concat(capitalize(name), "WithStyles");
      Object.defineProperty(Out, "name", {
        "value": Out.displayName
      });
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any


    return Out;
  }

  return {
    withStyles: withStyles
  };
}

function incorporateMediaQueries(cssObjectByRuleNameWithMediaQueries) {
  var cssObjectByRuleName = {};
  var cssObjectByRuleNameWithMediaQueriesByMediaQuery = {};
  Object.keys(cssObjectByRuleNameWithMediaQueries).forEach(function (ruleNameOrMediaQuery) {
    return (ruleNameOrMediaQuery.startsWith("@media") ? cssObjectByRuleNameWithMediaQueriesByMediaQuery : cssObjectByRuleName)[ruleNameOrMediaQuery] = cssObjectByRuleNameWithMediaQueries[ruleNameOrMediaQuery];
  });
  Object.keys(cssObjectByRuleNameWithMediaQueriesByMediaQuery).forEach(function (mediaQuery) {
    var cssObjectByRuleNameBis = cssObjectByRuleNameWithMediaQueriesByMediaQuery[mediaQuery];
    Object.keys(cssObjectByRuleNameBis).forEach(function (ruleName) {
      var _a;

      return cssObjectByRuleName[ruleName] = Object.assign(Object.assign({}, (_a = cssObjectByRuleName[ruleName]) !== null && _a !== void 0 ? _a : {}), _defineProperty({}, mediaQuery, cssObjectByRuleNameBis[ruleName]));
    });
  });
  return cssObjectByRuleName;
}